import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchAllUsers = async () => {
  const response = await fetch(`${REACT_APP_VMS_BASE_URL}/users`);
  const result = await response.json();
  return result;
};

export default fetchAllUsers;
